__webpack_require__.p = "/apps/files_videoplayer/js/";